import ComparisonPage from './ComparisonPage';

export default function SimplyBookComparisonPage() {
  return <ComparisonPage competitorKey="simplybook" competitorName="SimplyBook.me" />;
}
